import gql from 'graphql-tag';

export default gql`
  query order($id: ID!) {
    order(id: $id) {
      id
      total
      subTotalBeforeVat
      totalItemPrice
      grossTotal
      items {
        total
        price
        note
        orderedPrice
        orderedPriceV2 {
          price
          vat
          vatIncluded
        }
        priceV2 {
          price
          vat
          vatIncluded
        }
        totalBeforeVat
        product {
          id
          name
          note
          price
          vat
          uomLocal
          uom
          inStock
          supplierInternalCode
          imageUrl
          baseUnit
          baseUom
          netUnit
          netUom
          priceV2 {
            price
            vat
            vatIncluded
          }
        }
        deliveryQuantity
        orderedQuantity
        deliveredNote
        unitPriceAfterDiscount
        amountAfterDiscount
        buyerNote
      }
      orderDate
      deliveryFee {
        additionalVat
        fee
        discount
        active
      }
      deliveryTime {
        start
        end
      }
      status
      statusText
      note
      buyer {
        id
        name
      }
      store {
        id
        name
        freeShipping
        moq
      }
      supplier {
        id
        name
        imageUrl
        location {
          address
          district
          city
        }
      }
      creator {
        id
        name
      }
      paymentMethod
      declineReason
      redelivery
      orderType
      zeroOrderInfo {
        reason
        orderId
        receiver
      }
      discount
      cancelledAudit {
        userName
        time
      }
      fulfillmentNote {
        fulfillmentNoteId
        fulfillmentNoteShortCode
        orderIds
        invoice {
          id
          uuid
          invoiceStatus
          fileUrl
          total
          invoiceDate
          fastInvoiceNo
        }
      }
      totalVat
      totalVatOnProducts
    }
  }
`;
